<template>
  <div>
    <div class="w-logo-cnt" title="Login">
      <img rel="preload" alt="Scm Group" class="w-logo" src="~[envbyven]/assets/images/logo.png" />
    </div>
    <div class="oval">
      <img rel="preload" src="~@/assets/images/user.png" alt="User" />
    </div>
    <form class="form-signin" @submit.prevent="login">
      <!-- Login -->
      <div v-if="!forgotPassword" class="row">
        <div v-if="isLoginWithEmail" class="mp-0">
          <input-form
            :id="'inputEmail'"
            v-model="loginEmail"
            :lbl="'misc.email'"
            :lbl_error="validationErrors.loginEmail"
            :placeholder="'you@example.com'"
            :title="'Insert email address'"
            :autofocus="true"
            class="w-login-cnt-input"
          />
        </div>
        <div class="mp-0 w-input-pwd">
          <input-form
            :id="'inputPassword'"
            v-model="input.password"
            :type="!showPassword ? 'password' : 'text'"
            :lbl="'login.password'"
            :lbl_error="validationErrors.password"
            :placeholder="'Insert here'"
            class="w-login-cnt-input"
          />
          <div
            title="Show / hide password"
            class="w-show-password"
            @click="showPassword = !showPassword"
          >
            <i class="fas" :class="{ 'fa-eye': !showPassword, 'fa-eye-slash': showPassword }" />
          </div>
        </div>
        <div class>
          <a
            class="link"
            @click="
              forgotPassword = !forgotPassword;
              clear();
            "
            >{{ $t("login.forgot_password") }}</a
          >
        </div>
        <button
          class="btn-block btn-iot btn-login"
          :disabled="disableLogin"
          type="submit"
          @submit.prevent="login()"
        >
          Login
          <i class="fas fa-spinner fa-spin spin-off" :class="{ active: spinOff }" />
        </button>
      </div>
      <!-- Reset password -->
      <div v-else class="row">
        <input-form
          id="inputResetEmail"
          v-model="input.resetPasswordEmail"
          :lbl="'misc.email'"
          :lbl_error="validationErrors.resetPasswordEmail"
          placeholder="Insert email"
          class="w-login-cnt-input"
        />
        <p class="w-lbl">{{ $t("login.send_email_password") }}</p>
        <div class="col-xs-6 text-center">
          <button
            class="btn-block btn-iot btn-login"
            type="button"
            @click="
              forgotPassword = !forgotPassword;
              clear();
            "
          >
            {{ $t("misc.cancel") }}
          </button>
        </div>
        <div class="col-xs-6 text-center">
          <button
            class="btn-block btn-iot btn-login"
            :disabled="!input.resetPasswordEmail"
            type="button"
            @click="resetPassword()"
          >
            {{ $t("misc.send") }}
            <i class="fas fa-spinner fa-spin spin-off" :class="{ active: spinOff }" />
          </button>
        </div>
      </div>
      <div v-if="!isLoginWithEmail" id="new-login-notification" class="row text-center">
        {{ $t("login.new_login_notification") }}:
        <a href="/login">{{ loginUrl }}</a>
      </div>
    </form>
  </div>
</template>

<script>
import { validationUtils } from "@/components/mixins/validationUtils";
import InputForm from "@/components/widgets/form/inputTextForm";

export default {
  name: "Login",
  components: {
    InputForm
  },
  mixins: [validationUtils],
  props: {
    isLoginWithEmail: Boolean
  },
  data() {
    return {
      input: {
        password: "",
        loginEmail: "",
        resetPasswordEmail: ""
      },
      spinOff: true,
      forgotPassword: false,
      showPassword: false,
      loginUrl: "",
      validationErrors: {}
    };
  },
  computed: {
    enableLogin() {
      return this.isLoginWithEmail && this.input.loginEmail !== "" && this.input.password !== ""
        ? true
        : false;
    },
    disableLogin() {
      return !this.spinOff; // !this.enableLogin ||
    },
    loginEmail: {
      get() {
        return this.input.loginEmail;
      },
      set(val) {
        this.input.loginEmail = val.trim();
      }
    }
  },
  updated() {},
  mounted() {
    // Clear all local storage
    localStorage.clear();
  },
  created() {
    this.loginUrl = window.location.hostname + "/login";
  },
  methods: {
    login() {
      this.validationErrors = {};

      const th = this;
      if (this.isLoginWithEmail && this.validateLogin()) {
        this.spinOff = false;
        this.input["isLoginWithEmail"] = this.isLoginWithEmail;
        this.$store
          .dispatch("User/login", this.input)
          .then(async () => {
            try {
              if (this.$route.query.redirect_uri) {
                await this.$router.push(this.$route.query.redirect_uri);
              } else {
                // Go to machine page
                await this.$router.push({
                  name: "machine_map_overview"
                });
              }
            } catch (e) {
              console.error("Login error:", e && e.message);
            }
          })
          .catch(e => {
            console.error("[Login] Login error:", e);
            th.spinOff = true;
            th.clearToken();
          });
      } else {
        this.clearToken();
      }
    },
    clearToken() {
      this.spinOff = true;
      delete localStorage.token;
    },
    resetPassword() {
      const th = this;
      th.validationErrors = {};
      if (th.validateResetPassword()) {
        th.spinOff = false;
        th.$store
          .dispatch("User/resetPassword", this.input.resetPasswordEmail)
          .then(function () {
            const e = { message: th.$t("login.send_email_ok"), result: {} };
            th.$store.dispatch("Alert/setVal", e);
            th.spinOff = true;
            th.forgotPassword = false;
            th.clear();
          })
          .catch(() => {
            th.spinOff = true;
            th.clearToken();
          });
      }
    },
    clear() {
      this.input.loginEmail = "";
      this.input.resetPasswordEmail = "";
      this.input.password = "";
      this.validationErrors = {};
    },
    validateResetPassword() {
      const res = {};
      if (
        !!this.forgotPassword &&
        !!this.input.resetPasswordEmail &&
        !this.emailIsValid(this.input.resetPasswordEmail)
      ) {
        res.resetPasswordEmail = "errors.email_not_valid";
      }

      if (!this.IsEmptyValidationErrors(res)) {
        res.errors = true;
        Object.assign(this.validationErrors, res);
      }
      return this.IsEmptyValidationErrors(res);
    },
    validateLogin() {
      const res = {};
      if (!!this.input.loginEmail && !this.emailIsValid(this.input.loginEmail)) {
        res.loginEmail = "errors.email_not_valid";
      }
      if (!this.input.password) {
        res.password = "misc.required";
      }
      if (!this.input.loginEmail) {
        res.loginEmail = "misc.required";
      }

      if (!this.IsEmptyValidationErrors(res)) {
        res.errors = true;
        Object.assign(this.validationErrors, res);
      }
      return this.IsEmptyValidationErrors(res);
    },
    IsEmptyValidationErrors(val) {
      return Object.getOwnPropertyNames(val).length <= 0;
    }
  }
};
</script>
<style lang="scss">
.w-logo-cnt {
  color: #003c79;
  font-family: Arial;
  font-size: 20px;
  letter-spacing: -1.4px;
  line-height: 23px;
}
.w-show-password:hover {
  cursor: pointer;
}
.w-logo {
  max-height: 22px;
}
.oval {
  box-sizing: border-box;
  height: 58px;
  width: 58px;
  margin: auto;
  margin-top: 40px;
}
.oval img {
  border-radius: 50%;
  width: 100%;
}
.form-signin {
  width: 75%;
  margin: auto;
}
.form-signin .lbl {
  color: #333333;
  font-size: 13px;
  line-height: 15px;
  text-transform: uppercase;
}

.form-signin .form-control {
  padding: 20px 10px;
}
.form-signin p {
  margin-top: 20px;
}
.btn-login {
  box-sizing: border-box;
  height: 41px;
  width: 121px;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  margin: 40px auto;
  outline: none;
}
.w-show-password {
  box-sizing: border-box;
  font-size: 24px;
  text-align: center;
  outline: none;
  color: #002c70;
  display: table-cell;
  vertical-align: middle;
  position: absolute;
  right: 0;
  top: 15px;
  padding: 10px;
}
.btn-login:disabled {
  border: 1px solid #eaeaea;
  background-color: #ffffff;
  color: #aaaaaa;
}
.spin-off.active {
  display: none;
}
.mp-0 {
  margin: 0px;
  padding: 0px;
}
.w-input-pwd {
  position: relative;
}

@media (max-width: 450px) {
  .oval {
    margin-top: 40px;
  }
  .btn-login {
    width: 100px;
  }
}

#new-login-notification {
  color: red;
  font-weight: bold;
  border: 2px red dashed;
  padding: 1rem;
  margin-bottom: 15px;
}
</style>
